import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import { EDIT_PROFILE, GET_PROFILE} from "./actionTypes";
import { profileSuccess, profileError } from "./actions";
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
    postFakeProfile,
    postJwtProfile
} from "../../../helpers/fakebackend_helper";
import { getUserId } from "../../../helpers/helper";
const fireBaseBackend = getFirebaseBackend();

function* editProfile({ payload: { user } }) {

    try {
        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            const response = yield call(
                fireBaseBackend.editProfileAPI,
                user.username,
                user.idx
            );
            yield put(profileSuccess(response));
        } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
            const response = yield call(postJwtProfile, "/post-jwt-profile", {
                username: user.username,
                idx: user.idx,
            });
            yield put(profileSuccess(response));
        } else if (process.env.REACT_APP_API_URL) {
            const response = yield call(postFakeProfile, user);
            yield put(profileSuccess(response));
        }
    } catch (error) {
        yield put(profileError(error));
    }
}

function* getProfile({  payload:  data }) {
    try {
        
        if (process.env.REACT_APP_API_URL) {
            const profileInfo = yield call(getUserId, data.userId);
            
            if(profileInfo) {
                //sessionStorage.setItem("profileUser", JSON.stringify(profileInfo));
                yield put(profileSuccess({data: profileInfo}));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(profileError('Bạn không quyền truy cập thông tin người dùng!'));
    }
}

export function* ProfileSaga() {
    yield takeEvery(EDIT_PROFILE, editProfile);
    yield takeEvery(GET_PROFILE, getProfile);
}

export default ProfileSaga;
